import {APIService} from "../../common/APIService";
import {Employee} from "../../dto/Employee";

export class EmployeeService extends APIService {
  public async browse() {
    const json = await this.getJson<{data: object[]}>(`employees`)
    return json.data.map(item => Employee.fromJson(item))
  }

  public async read(employeeId: string) {
    const json = await this.getJson<{data: object}>(`employees/${employeeId}`)
    return Employee.fromJson(json.data)
  }
}